import { createApp } from 'vue';
import GetTalentReportForm from '../../talent/GetTlntReportForm.vue'

const appElements = document.querySelectorAll('.vue-get-tlnt-form-view')
Array.from(appElements).forEach(element => {
  createApp(GetTalentReportForm).mount(element);
});